module.exports = __webpack_public_path__ + "img/failure-image.81fe01f8.svg";